import React from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/colorPickerStyles';
import { ColorPickerPosition } from './ColorSlider';

// @ts-ignore
const useStyles = makeStyles(styles);

export const ColorDot = ({
	isLightColor,
	color,
	unavailable,
}: {
	unavailable: boolean;
	isLightColor: boolean;
	color: string;
}) => {
	const classes = useStyles({ unavailable, isLightColor, color });
	return <div className={classes.colorDot}></div>;
};

export const ColorDotWrapper = ({
	selected,
	separator,
	size,
	position,
	first,
	last,
	onClick,
	children,
	available,
}: {
	selected: boolean;
	separator: number;
	size: number;
	position: ColorPickerPosition;
	first: boolean;
	last: boolean;
	available: boolean;
	onClick: () => void;
	children?: string | React.ReactElement | React.ReactElement[];
}) => {
	const classes = useStyles({ selected, separator, size, position, first, last, unavailable: !available });
	return (
		<div onClick={onClick} className={classes.colorDotWrapper}>
			{children}
		</div>
	);
};

export const CrossLine = () => {
	const classes = useStyles();
	return <div className={classes.crossLine}></div>;
};
